export enum TableColumnSearchType {
  text = 1,
  number,
  options,
  date,
  currency,
  textStartsWith,
  dateOnly,
}
